"use client";
import React from "react";
import dynamic from "next/dynamic";
import useLazyLoad from "@/lib/hooks/useLazyLoad";

const Comment = dynamic(
	() => import("./Comment"),

	{
		loading: () => <Skeleton className="  h-20 w-full"></Skeleton>,
	}
);

import { DataComment } from "@/types/Comment.type";
import Skeleton from "@/components/Skeleton";

export default function CommentLazy(props: DataComment) {
	const [ref, isIntersecting] = useLazyLoad();
	return (
		<div ref={ref}>
			{isIntersecting ? <Comment {...props}></Comment> : null}
		</div>
	);
}
